import React from "react";
// import PropTypes from "prop-types";
import { FormControl, InputGroup } from "react-bootstrap";
import { FeatureCard } from "@components/FeatureCard";
import { TabContent } from "@components";
import classes from "./styles/HelpPage.module.css";

const HelpPage = () => {
  const data = [
    {
      icon: <i className="bi bi-archive"></i>,
      title: "Go at your own pace",
      subtitle: "Select from top instructors around the world",
    },
    {
      icon: <i className="bi bi-archive"></i>,
      title: "Go at your own pace",
      subtitle: "Select from top instructors around the world",
    },
    {
      icon: <i className="bi bi-archive"></i>,
      title: "Go at your own pace",
      subtitle: "Select from top instructors around the world",
    },
    {
      icon: <i className="bi bi-archive"></i>,
      title: "Go at your own pace",
      subtitle: "Select from top instructors around the world",
    },
    {
      icon: <i className="bi bi-archive"></i>,
      title: "Go at your own pace",
      subtitle: "Select from top instructors around the world",
    },
    {
      icon: <i className="bi bi-archive"></i>,
      title: "Go at your own pace",
      subtitle: "Select from top instructors around the world",
    },
  ];

  const InstructorTab = (
    <div className="p-4">
      <h4>Select a topic to search for help</h4>
      <div className="row mt-4">
        {data.map((item, index) => {
          return (
            <div key={index} className="col-lg-4 col-xs-6">
              <FeatureCard
                icon={item.icon}
                title={item.title}
                subtitle={item.subtitle}
              />
            </div>
          );
        })}
      </div>
      <h4>Frequently Asked Questions</h4>
      <div className="row mt-4">
        {data.map((item, index) => {
          return (
            <div key={index} className="col-lg-4 col-xs-6">
              <div className="bg-white mb-4 border text-center">
                <div className="p-3">
                  <span>Lorem ipsum dolor sit</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const StudentTab = (
    <div className="p-4">
      <h4>Select a topic to search for help</h4>
      <div className="row mt-4">
        {data.map((item, index) => {
          return (
            <div key={index} className="col-lg-4 col-xs-6">
              <FeatureCard
                icon={item.icon}
                title={item.title}
                subtitle={item.subtitle}
              />
            </div>
          );
        })}
      </div>
      <h4>Frequently Asked Questions</h4>
      <div className="row mt-4">
        {data.map((item, index) => {
          return (
            <div key={index} className="col-lg-4 col-xs-6">
              <div className="bg-white mb-4 border text-center">
                <div className="p-3">
                  <span>Lorem ipsum dolor sit</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const tabList = [
    {
      id: "instructor",
      title: "Instructor",
      content: InstructorTab,
    },
    {
      id: "student",
      title: "Student",
      content: StudentTab,
    },
  ];

  return (
    <div>
      <div className={classes.wrapper}>
        <h4 className="mb-4">How may we help you?</h4>
        <InputGroup className="mb-3 w-50 m-auto">
          <InputGroup.Text className="bg-white">
            <i className="bi bi-search"></i>
          </InputGroup.Text>
          <FormControl
            placeholder="Username"
            aria-label="Username"
            aria-describedby="basic-addon1"
            className="border-left-0"
          />
        </InputGroup>
      </div>
      <TabContent data={tabList} navClassName="bg-white pt-3" />
    </div>
  );
};

/* required: display name */
HelpPage.displayName = "HelpPage";

/* required: props types */
HelpPage.propTypes = {};

/* required: default props */
HelpPage.defaultProps = {};

export { HelpPage };
